// A note's cover colour (Carla's decision 4, 2026-10-12): stored as the kit token NAME, never a
// colour value. The server accepts exactly these names (routes/notes.js NOTE_COVERS); a backend
// test pins the two lists together and to ui/tokens.js, so one cannot change alone.
export const NOTE_COVERS = [
  ['pastel-blue', 'Blue'],
  ['pastel-green', 'Green'],
  ['pastel-mint', 'Mint'],
  ['pastel-yellow', 'Yellow'],
  ['pastel-orange', 'Orange'],
  ['pastel-pink', 'Pink'],
  ['pastel-lilac', 'Lilac'],
  ['pastel-periwinkle', 'Periwinkle'],
];

export const coverName = (token) => (NOTE_COVERS.find(([k]) => k === token) || [])[1] || null;
